module.exports = __webpack_public_path__ + "img/img8.a14b9996.svg";